<mat-toolbar class="header">
  <div class="logo-box">
    <img src="./images/logo/ey-logo.svg" class="logo" alt="EY" />
  </div>
  <div class="heading-box">
    <h1 class="heading">{{ getLocation() }}</h1>
  </div>
  <div class="powered-by px-2">
    <span>Powered by </span>
    <a href="#">Global Consulting AI Engine Room</a>
  </div>
  <div class="spacer"></div>
  <div class="select-box">
    <motif-select
      [(ngModel)]="tenant"
      aria-label="Level Filter"
      selectTitle="Select all"
      [showSelectAllButton]="true"
      (selectionChange)="onTenantChange($event)"
      [multiple]="false"
      placeholder="Select tenant"
      labelPosition="inside"
    >
      <motif-option *ngFor="let level of tenantOptions" [value]="level.value">{{
        level.label
      }}</motif-option>
    </motif-select>
  </div>

  <div class="profile-box">
    <div
      class="avatar-box"
      [matMenuTriggerFor]="menu"
      #menuTrigger="matMenuTrigger"
    >
      <ng-container *ngIf="profilePicBase64; else noPhoto">
        <img
          [src]="profilePicBase64"
          alt="User Avatar"
          class="avatar"
        />
      </ng-container>
      <ng-template #noPhoto>
        <div class="avatar avatar-initials" aria-label="User initials">{{
          userInitials
        }}</div>
      </ng-template>
      <div class="online-indicator online"></div>
    </div>
  </div>
</mat-toolbar>
<mat-menu #menu="matMenu" class="menu-panel">
  <div class="profile-menu">
    <!-- <button mat-menu-item (click)="goToAdmin()">
      <mat-icon>manage_accounts</mat-icon>
      <span>Rule Engine</span>
    </button> -->
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </div>
</mat-menu>
